const NumberOperators = {
    equals: {
        id: 'equals',
        matcher: (value, matchValue) => {
            return value === parseFloat(matchValue);
        }
    },
    less_than: {
        id: 'less_than',
        matcher: (value, matchValue) => {
            return value < parseFloat(matchValue);
        }
    },
    more_than: {
        id: 'more_than',
        matcher: (value, matchValue) => {
            return value > parseFloat(matchValue);
        }
    },
    between: {
        id: 'between',
        matcher: (value, matchValue) => {
            const splitPart = matchValue.split(',');
            const first = parseFloat(splitPart[0].trim());
            const second = parseFloat(splitPart[1].trim());
            return value > first && value < second;
        }
    }
};
module.exports.NumberOperators = NumberOperators;